import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpStatusCode,
} from '@angular/common/http';
import { AuthService } from './auth.service';
import {
  EMPTY,
  Observable,
  catchError,
  map,
  switchMap,
  throwError,
  zip,
} from 'rxjs';
import { NavController } from '@ionic/angular';
import { Injectable } from '@angular/core';
import { CUSTOM_CONTEXT } from '../api/api.enums';

@Injectable()
export class AuthInterceptorService implements HttpInterceptor {
  constructor(
    private readonly authService: AuthService,
    private readonly navCtrl: NavController
  ) {}
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (request.context.get(CUSTOM_CONTEXT.SKIP_AUTH_INTERCEPTOR) === true) {
      return next.handle(request);
    }
    return this.authService.getStoredAuthData().pipe(
      map((authData) => {
        return !authData
          ? request
          : request.clone({
              setHeaders: { Authorization: `Bearer ${authData?.token}` },
            });
      }),
      switchMap((request) =>
        next.handle(request).pipe(
          catchError((err) => {
            return zip(
              this.authService.isStoredTokenExpired(),
              this.authService.getStoredAuthData()
            ).pipe(
              switchMap(([isTokenExpired, storedAuthData]) => {
                if (err instanceof HttpErrorResponse) {
                  if (err.status === 401 && storedAuthData && request.url !== this.authService.refreshTokenUrl) {
                    return this.authService
                      .refreshToken({
                        refreshToken: storedAuthData.refreshToken,
                      })
                      .pipe(
                        catchError((err) => {
                          this.authService.logout().subscribe();
                          this.navCtrl.navigateRoot('login');
                          return EMPTY;
                        }),
                        switchMap((authData) => {
                          const newReq = request.clone({
                            setHeaders: {
                              Authorization: `Bearer ${authData!.token}`,
                            },
                          });
                          return next.handle(newReq);
                        })
                      );
                  }
                  if (err.status === 401) {
                    this.authService.logout().subscribe();
                    this.navCtrl.navigateRoot('login');
                    return EMPTY;
                  }
                }
                return throwError(() => err);
              })
            );
          })
        )
      )
    );
  }
}
